module.exports = __webpack_public_path__ + "a36b870a1fc657dfe5981f06764375d8.svg";